import React from 'react';
import { Typography } from 'antd';
import { useTranslation, Trans } from 'react-i18next';
import {getSetting, getUserData} from '../../../utils/functions';

const { Title, Paragraph } = Typography;

const containerStyle = {
    display: 'flex',
    gap: '25px',
    justifyContent: 'center',
    alignItems: 'normal',
    marginBottom:'20px'
};

const cardStyle = {
    backgroundColor: '#f6f6f6',
    borderRadius: '10px',
    padding: '22px',
    boxShadow: '0 3px 8px rgba(0, 0, 0, .2)'
};

const welcomeCardStyle = {
    ...cardStyle,
    flex: 2,
};

const textStyle = {
    fontFamily: 'Poppins,sans-serif',
    color: '#000',
    fontSize: '14px',
    lineHeight: '20px',
    fontStyle: 'normal',
    fontWeight: '400',
    marginBottom: '1em'
};

const titleStyle = {
    fontFamily: 'Poppins,sans-serif',
    fontWeight: '600',
    color: '#000',
    fontSize: '16px',
    marginBottom: '16px',
};

const linkStyle = {
    color: '#467886',
    textDecoration: 'underline',
    fontWeight: '700',
};

const logoStyle = {
    height: '93px',
    marginBottom: '20px',
};

const WelcomeCard = () => {
    const user = getUserData();
    const name = user.first_name.charAt(0).toUpperCase() + user.first_name.slice(1);
    const { t } = useTranslation();
    return (
        <div style={containerStyle}>
            <div style={welcomeCardStyle}>
                {
                    getSetting('logo') !== "" &&
                    <img src={getSetting('logo')} alt="Logo" style={logoStyle}/>
                }

                <Title level={4} style={titleStyle}>
                    {t('home.welcome.title', {name})}
                </Title>
                <Paragraph style={textStyle}>
                    <Trans
                        i18nKey='home.welcome.intro'
                        components={{
                            br: <br />
                        }}
                    />
                </Paragraph>
                <Paragraph style={textStyle}>
                    <Trans
                        i18nKey='home.welcome.support'
                        components={{
                            br: <br />
                        }}
                    />
                </Paragraph>
                <Paragraph style={textStyle}>
                    {t('home.welcome.contact')}{' '}
                    <a href="mailto:yof_support@crg.ca" style={linkStyle}>
                        yof_support@crg.ca
                    </a>
                </Paragraph>
            </div>
        </div>
    );
}
export default WelcomeCard;